import {defineRecipe} from '@chakra-ui/react3'

export default defineRecipe({
    base: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: 'spacing-4',
        alignContent: 'center'
    }
})
